import debounce from './debounce';
import throttle from './throttle';

const $common = {
    debounce,
    throttle,
}

export default $common;